// src/Pages/NotFound.js

import React from 'react';


const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">Oops! The page you are looking for does not exist.</p>
        <a href="/" className="not-found-button">Go to Homepage</a>
      </div>
    </div>
  );
};

export default NotFound;
